// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cursor-pointer{
  cursor: pointer;
}

.processing-node{
  position: absolute;
    top: -25px;
    left: 0;
    right: 0;
    /* bottom: 0; */
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    /* background: #ffffffe3; */
    z-index: 9;
    color: #f8be45;
    font-size: 14px;
}

.modal.show .modal-dialog {
  transform: translate(0, 0%) !important;
}

.pl-20{
  padding-left: 20px;
}
.or-text {
  text-align: center;
  position: relative;
  height: 40px;
  margin-bottom: 10px;
}
.or-text p {
  line-height: 40px;
  margin: 0;
  z-index: 999;
  position: relative;
  display: inline-block;
  width: auto;
  padding: 0 10px;
  background: #fff;
  font-weight: 500;
  color: #676767;
  z-index: 1;
}
.or-text:after {
  content: "";
  height: 2px;
  background: #f5f5f5;
  position: absolute;
  left: 40px;
  right: 40px;
  top: 48%;
  display: block;
}

.form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control{
  background-color: #1d253b24 !important;
}

.boolean-input{
  display: block;
  width: 180px;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;IAChB,UAAU;IACV,OAAO;IACP,QAAQ;IACR,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,2BAA2B;IAC3B,UAAU;IACV,cAAc;IACd,eAAe;AACnB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,UAAU;AACZ;AACA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,YAAY;AACd","sourcesContent":[".cursor-pointer{\r\n  cursor: pointer;\r\n}\r\n\r\n.processing-node{\r\n  position: absolute;\r\n    top: -25px;\r\n    left: 0;\r\n    right: 0;\r\n    /* bottom: 0; */\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    text-align: center;\r\n    /* background: #ffffffe3; */\r\n    z-index: 9;\r\n    color: #f8be45;\r\n    font-size: 14px;\r\n}\r\n\r\n.modal.show .modal-dialog {\r\n  transform: translate(0, 0%) !important;\r\n}\r\n\r\n.pl-20{\r\n  padding-left: 20px;\r\n}\r\n.or-text {\r\n  text-align: center;\r\n  position: relative;\r\n  height: 40px;\r\n  margin-bottom: 10px;\r\n}\r\n.or-text p {\r\n  line-height: 40px;\r\n  margin: 0;\r\n  z-index: 999;\r\n  position: relative;\r\n  display: inline-block;\r\n  width: auto;\r\n  padding: 0 10px;\r\n  background: #fff;\r\n  font-weight: 500;\r\n  color: #676767;\r\n  z-index: 1;\r\n}\r\n.or-text:after {\r\n  content: \"\";\r\n  height: 2px;\r\n  background: #f5f5f5;\r\n  position: absolute;\r\n  left: 40px;\r\n  right: 40px;\r\n  top: 48%;\r\n  display: block;\r\n}\r\n\r\n.form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control{\r\n  background-color: #1d253b24 !important;\r\n}\r\n\r\n.boolean-input{\r\n  display: block;\r\n  width: 180px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
